import { STATUS_LABELS, STATUS_TONES, formatMeasurement, measurementLabelOf, measurementTypeOf } from '../../domain';
import { formatDateTime } from '../../modules/generic/patient-detail/history-table';
import { BucketReadingScope, BucketReadingsScope } from './bucket-readings.scope';
/**
 * Quem controla o detalhamento de uma celula do historico: as leituras cruas que ela
 * resumiu.
 *
 * Duas telas o hospedam - o detalhe do paciente e o historico compartilhado por link.
 * As duas desenham a mesma tabela agrupada por hora e diferem so em DE ONDE as
 * leituras vem (o id do paciente, ou o codigo do link). Por isso quem busca e o
 * hospedeiro, que entrega a busca em `open`; o dialogo nao sabe qual das duas e.
 *
 * Presenter sem place, como o editor de faixas: abrir o detalhamento nao e destino, e
 * nao vai para o endereco.
 */
export class BucketReadingsPresenter {
    constructor(update) {
        this.update = update;
        this.scope = new BucketReadingsScope();
        /**
         * Token de requisicao: fechar, ou abrir outra celula, enquanto a anterior ainda
         * carrega deixa a resposta atrasada calada.
         */
        this.pending = 0;
        this.scope.update = update;
        this.scope.onClose = this.close.bind(this);
    }
    /**
     * Abre o detalhamento da celula `typeId` x `hour`, com as leituras que `fetch` trouxer.
     *
     * O titulo diz o tipo e a hora antes de a rede responder, e o dialogo abre com o
     * indicador de carga - quem clicou ve que algo aconteceu, em vez de esperar em
     * silencio por uma janela que ainda nao existe.
     *
     * Se a busca falhar, o dialogo fecha e o erro SOBE para o hospedeiro: e ele quem
     * sabe o que a falha significa (no link publico, um 410 e o link vencido). A falha
     * de uma busca que ja perdeu a corrida fica calada.
     */
    async open(typeId, hour, fetch) {
        const token = ++this.pending;
        this.scope.open = true;
        this.scope.loading = true;
        this.scope.readings = [];
        this.scope.title = `${measurementLabelOf(typeId)} - ${formatDateTime(hour)}`;
        let readings;
        try {
            readings = await fetch();
        }
        catch (caught) {
            if (token !== this.pending) {
                return;
            }
            this.scope.open = false;
            this.scope.loading = false;
            throw caught;
        }
        if (token !== this.pending) {
            return;
        }
        const hasStatus = measurementTypeOf(typeId)?.hasStatus === true;
        this.scope.readings = readings.map((reading) => {
            const scope = new BucketReadingScope();
            scope.identity = reading.date;
            // So a HORA: o dia ja esta no titulo, e repeti-lo em cada linha de uma
            // lista que pode ter centenas so gasta largura.
            scope.time = reading.date.slice(11, 19);
            scope.value = formatMeasurement(typeId, reading.value);
            if (hasStatus) {
                scope.statusName = STATUS_LABELS[reading.statusLevel];
                scope.statusColor = STATUS_TONES[reading.statusLevel];
            }
            scope.update = this.update;
            return scope;
        });
        this.scope.loading = false;
    }
    /** Fecha o detalhamento. As leituras saem do scope junto: nao ha por que guardar. */
    async close() {
        ++this.pending;
        this.scope.open = false;
        this.scope.loading = false;
        this.scope.readings = [];
    }
}
//# sourceMappingURL=bucket-readings.presenter.js.map